import React from "react"
import { connect } from "react-redux"
import { push } from "connected-react-router"
import { keys, omit } from "lodash"
import Ajax from "superagent"

import { products}  from "../../../../data"
import CoolPage from "../components/CoolPage"
import { updateUserData } from "../actions/index"
import { getSelections } from "../selectors"

import PhoneCodeModal from './components/PhoneCodeModal'
import phoneCodes from './phoneCodes'

import './FormPage.less'

function createProductFromCar(car) {
  return {
    _id: 'car',
    name: car.display_name
  }
}

function validateData(data) {
  let errors = {}
  let isValid = true
  keys(data).forEach(key => {
    if (!data[key]) {
      errors = {...errors, [key]: true}
      isValid = false
    }
  })
  return !isValid ? errors : null
}

class FormPage extends React.PureComponent {
  constructor(props) {
    super(props)

    const { userData } = this.props

    this.state = {
      name: userData.name || "",
      prefix: userData.prefix || "+34",
      phone: userData.phone || "",
      email: userData.email || "",
      comment: "",
      showModal: false,
      errors: {}
    }
  }

  render() {
    const { product = {} } = this.props
    return  (
      <CoolPage
        title={product.chName || product.name}
        footerButton
        footerDisabled={validateData(omit(this.state, ['comment', 'showModal']))}
        fixedBar
        onFooterClick={() => {
          const errors = validateData(omit(this.state, ['comment', 'showModal']))
          this.setState({ errors: errors || {}})
          if (!errors) {
            Ajax
              .get("/checkPhone")
              .query({prefix: this.state.prefix, phone: this.state.phone})
              .then(res => {
                if (res.body) {
                  this.props.updateUserData(omit(this.state, "errors"))
                  this.props.push(`/catalogo/${this.props.city ? `${this.props.city}/` : ''}reservation/reviewpage/${this.props.product._id}`)
                }
                else this.setState({showModal: true})
              })
          }
        }}
        footerLabel="下一步"
        transparentBar
        containerProps={{ id: "NewFormPage" }}
      >
        <div id="NewFormPage">
          <div className="title">个人信息</div>

          <div>
            <p className="minititle">姓名</p>
            <input 
              className={this.state.errors.name ? "error" : ""}
              value={this.state.name}
              placeholder="张先生"
              onChange={evt => this.setState({name: evt.target.value, errors: {...this.state.errors, name: false}})}
            />
          </div>
          
          <div>
            <select 
              className="round"
              onChange={evt => this.setState({prefix: evt.target.value})}
            >
              {
                [
                  { key: "c34",  code: "+34",  paren: "西班牙" }, // spain
                  { key: "c86",  code: "+86",  paren: "中国" },   // china
                  { key: "c852", code: "+852", paren: "香港" },   // hk
                  { key: "c886", code: "+886", paren: "台湾" },   // taiwan
                ].map(({code, paren, key}) => (
                  <option selected={this.state.prefix == code} key={key} value={code}>
                    {code}
                    {' '}
(
                    {paren}
)
                  </option>
                ))
              }
              <option disabled>──────────</option>
              {
                phoneCodes.map(x => <option selected={this.state.prefix == x} key={x} value={x}>{x}</option>)
              }
            </select>
            <input 
              className={this.state.errors.phone ? "error" : ""}
              value={this.state.phone}
              placeholder=" 输入手机号码"
              type="number"
              onChange={evt => this.setState({phone: evt.target.value, errors: {...this.state.errors, phone: false}})}
            />
          </div>
          
          <div>
            <p className="minititle">邮箱</p>
            <input 
              className={this.state.errors.email ? "error" : ""}
              value={this.state.email}
              placeholder="输入邮箱地址"
              onChange={evt => this.setState({email: evt.target.value, errors: {...this.state.errors, email: false}})}
            />
          </div>
          
          <div>
            <div className="minititle comentario">
              <p>添加评论</p>
              <p>
                {this.state.comment.length}
/200
              </p>
            </div>
            <textarea 
              maxLength="200"
              placeholder="订单备注"
              value={this.state.comment}
              onChange={evt => this.setState({comment: evt.target.value})}
            />
          </div>

          {this.state.showModal && (
            <PhoneCodeModal 
              onClose={() => this.setState({showModal: false})}
              prefix={this.state.prefix}
              phone={this.state.phone}
              onSuccess={() => {
                this.props.updateUserData(omit(this.state, "errors"))
                this.props.push(`/catalogo/reservation/reviewpage/${this.props.product._id}`)
              }}
            /> 
          )}
          
        </div>
      </CoolPage>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const {id, city} = ownProps.match.params
  const product = id == 'car' ? createProductFromCar(state.transportation[city].selectedCar) : products[id] || products[encodeURIComponent(id)]
  return {
    product,
    city,
    userData: getSelections(state, ownProps).userData || {},
  }
}

const mapDispatchToProps = dispatch => ({
  push: (url) => dispatch(push(url)),
  updateUserData: payload => dispatch(updateUserData(payload)),
})


export default connect(mapStateToProps, mapDispatchToProps)(FormPage)


// WEBPACK FOOTER //
// ./src/app/catalogo/reservation/FormPage.jsx